// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../views/modules/two-column-c-t-a/assets/scss/two-column-c-t-a.scss
// module id = 133
// module chunks = 1